import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopContext } from '../Context/ShopContext';
import { FiArrowLeft, FiMapPin, FiSave } from 'react-icons/fi';
import './Address.css';

const Address = () => {
    const { user, updateCustomerAddress } = useContext(ShopContext);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        addressLine1: '',
        addressLine2: '',
        district: '',
        state: '',
        pincode: ''
    });

    useEffect(() => {
        if (user?.defaultAddress) {
            setFormData({
                name: user.defaultAddress.name || '',
                addressLine1: user.defaultAddress.addressLine1 || '',
                addressLine2: user.defaultAddress.addressLine2 || '',
                district: user.defaultAddress.district || '',
                state: user.defaultAddress.state || '',
                pincode: user.defaultAddress.pincode || ''
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const success = await updateCustomerAddress(formData);
        if (success) {
            navigate('/cart');
        }
    };

    return (
        <div className="address-page container">
            <header className="address-header">
                <button className="back-btn" onClick={() => navigate('/cart')}>
                    <FiArrowLeft /> Back
                </button>
                <h1><FiMapPin /> Delivery Address</h1>
            </header>

            <form className="address-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Full Name (First and Last name) *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="John Doe" />
                </div>
                <div className="form-group">
                    <label>Flat, House no., Building, Company, Apartment *</label>
                    <input type="text" name="addressLine1" value={formData.addressLine1} onChange={handleChange} required placeholder="House No 123, ABC Street" />
                </div>
                <div className="form-group">
                    <label>Area, Colony, Street, Sector, Village</label>
                    <input type="text" name="addressLine2" value={formData.addressLine2} onChange={handleChange} placeholder="Near Landmark" />
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label>District *</label>
                        <input type="text" name="district" value={formData.district} onChange={handleChange} required placeholder="Madurai" />
                    </div>
                    <div className="form-group">
                        <label>State *</label>
                        <input type="text" name="state" value={formData.state} onChange={handleChange} required placeholder="Tamil Nadu" />
                    </div>
                </div>
                <div className="form-group">
                    <label>Pincode *</label>
                    <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} required placeholder="625001" />
                </div>
                <button type="submit" className="save-address-btn">
                    <FiSave /> Save and Continue
                </button>
            </form>
        </div>
    );
};

export default Address;
